import Chip from "@mui/material/Chip";
import type { SourceStatus } from "../../../../lib/corpusApi";

const STATUS_MAP: Record<
  SourceStatus,
  { label: string; color: "default" | "warning" | "success" | "info" | "error" }
> = {
  pending: { label: "Pending", color: "warning" },
  ready: { label: "Ready", color: "info" },
  ingested: { label: "Ingested", color: "success" },
  revoked: { label: "Revoked", color: "error" },
};

export interface DocumentStatusBadgeProps {
  status: SourceStatus;
}

/** Chip rendering the lifecycle status of a corpus document. */
export function DocumentStatusBadge({ status }: DocumentStatusBadgeProps) {
  const { label, color } = STATUS_MAP[status];
  return <Chip label={label} color={color} size="small" />;
}
